/* NOTE:
   - Figma chart width: 148
   - Figma width with graph: 205
   - Our graph is centered and has an extra "rhs text" portion
     that figma does not
   - Our graph width should be (per calcs in simple-grid):
     (7/9)*x + (2/9)*x + (2/9) * x = 57 where x is 1/2 of what
     our margin width should be
     our_margin_width = 2*x = 2 * (57 * (9/11)) = 93.2
     our_width_with_graph = 148 + 93 = 241
   - However, figma doesn't account for first decimal place.
     So we will use 250 */
export const BUDGET_MIX_WIDTH = 148;
export const BUDGET_MIX_WIDTH_WITH_CHART = 400;
